module.exports = __webpack_public_path__ + "img/google.12c407a8.svg";